import { render } from "./ProdutosView.vue?vue&type=template&id=20e09424"
import script from "./ProdutosView.vue?vue&type=script&lang=js"
export * from "./ProdutosView.vue?vue&type=script&lang=js"

import "./ProdutosView.vue?vue&type=style&index=0&id=20e09424&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__